(function(){if(window.__odeliseWheelScrollFix)return;window.__odeliseWheelScrollFix=true;function maxY(){return Math.max(0,(document.documentElement.scrollHeight||0)-window.innerHeight);}window.addEventListener('wheel',function(e){var y=window.scrollY||document.documentElement.scrollTop||0;if(maxY()>0){window.scrollTo(0,Math.max(0,Math.min(maxY(),y+e.deltaY)));e.preventDefault();}}, {passive:false});})();

(function(){
  function contentHeight(){
    var max = 0;
    var nodes = document.body ? document.body.querySelectorAll('body > *') : [];
    for(var i = 0; i < nodes.length; i++){
      var el = nodes[i];
      if(!el || el.id === 'htb02-height-postmessage') continue;
      var cs = window.getComputedStyle(el);
      if(cs.display === 'none' || cs.visibility === 'hidden') continue;
      if(cs.position === 'fixed') continue;
      var rect = el.getBoundingClientRect();
      if(!rect || rect.height <= 0) continue;
      max = Math.max(max, rect.bottom + window.scrollY);
    }
    return Math.ceil(max);
  }
  function h(){
    var measured = contentHeight();
    if(measured > 800) return measured;
    return Math.max(800, document.documentElement ? document.documentElement.clientHeight : 0);
  }
  function send(){
    if(window.parent && window.parent !== window){
      window.parent.postMessage({type:'htb02OdeliseHeight', height:h()}, '*');
    }
  }
  window.addEventListener('load', send);
  window.addEventListener('resize', send);
  window.addEventListener('message', function(event){ if(event.data && event.data.type === 'htb02RequestHeight') send(); });
  if('ResizeObserver' in window){ new ResizeObserver(send).observe(document.body || document.documentElement); }
  setTimeout(send, 50); setTimeout(send, 500); setTimeout(send, 1500);
})();


(function(){
  function send(){
    var trigger = document.getElementById('itksswy');
    if(!trigger || !window.parent || window.parent === window) return;
    window.parent.postMessage({type:'htb02StickyTriggerOffset', offset: trigger.offsetTop}, '*');
  }
  if(document.readyState !== 'loading') send(); else document.addEventListener('DOMContentLoaded', send);
  window.addEventListener('load', send); window.addEventListener('resize', send);
  setTimeout(send,100); setTimeout(send,500); setTimeout(send,1500);
})();


(function(){
  function suffix(n){return (n%10==1&&n%100!=11)?'st':(n%10==2&&n%100!=12)?'nd':(n%10==3&&n%100!=13)?'rd':'th';}
  function fmt(d){var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];return days[d.getDay()]+' . '+months[d.getMonth()]+' . '+d.getDate()+' '+suffix(d.getDate())+' , '+d.getFullYear()+' | 11:11 am EST';}
  var d=new Date(); d.setDate(d.getDate()-2);
  var txt=fmt(d);
  document.body.innerHTML=document.body.innerHTML.replace(/[A-Z][a-z]{2}\s*\.\s*[A-Z][a-z]{2}\s*\.\s*\d{1,2}\s*(?:st|nd|rd|th)\s*,\s*20\d{2}\s*\|\s*11:11\s*am\s*EST/g, txt);
})();


(function(){
  var root=document.getElementById('back-support-report-native');
  var dest='https://odelise.com/pages/baresupport-offer';
  function shouldRoute(el){
    if(!el) return false;
    var txt=((el.getAttribute('data-text-value')||'')+' '+(el.textContent||'')+' '+(el.getAttribute('title')||'')+' '+(el.getAttribute('action')||'')).toLowerCase();
    return txt.indexOf('get ')>-1 || txt.indexOf('try ')>-1 || txt.indexOf('order')>-1 || txt.indexOf('check availability')>-1 || txt.indexOf('38%')>-1 || txt.indexOf('today only')>-1 || txt.indexOf('route')>-1;
  }
  document.addEventListener('click',function(e){
    var el=e.target.closest && e.target.closest('a,button');
    if(!el || (root && !root.contains(el))) return;
    var href=el.getAttribute('href')||'';
    if(href && href.indexOf('#')!==0 && href.indexOf('javascript:')!==0) return;
    if(shouldRoute(el)){e.preventDefault(); window.location.href=dest;}
  },true);
})();